import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAccessToken } from "../../../utils/authStorage";

export default function AccountDetails() {
  const { id } = useParams();
  const [account, setAccount] = useState(null);
  const [price, setPrice] = useState(null);
  const [method, setMethod] = useState("matrixsols");
  const token = getAccessToken();

  useEffect(() => {
    fetch(`/api/v1/accounts/${id}`)
      .then((r) => r.json())
      .then((j) => {
        if (j.success) setAccount(j.account);
      });
    if (token) fetchPrice();
  }, [id]);

  async function fetchPrice() {
    const res = await fetch(`/api/v1/accounts/${id}/price`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const j = await res.json();
    if (j.success) setPrice(j.price);
  }

  async function buy() {
    if (!token) return alert("Please login");
    const res = await fetch(`/api/v1/accounts/${id}/purchase`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ method }),
    });
    const j = await res.json();
    if (!j.success) return alert(j.message || "Purchase failed");

    if (j.paymentUrl) window.location.href = j.paymentUrl;
    else alert("Purchased. Account details will be emailed.");
  }

  if (!account) return <div>Loading...</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>{account.title}</h2>
      <div style={{ display: "flex", gap: 12 }}>
        <div style={{ width: 400 }}>
          {account.images?.map((img, i) => (
            <img
              key={i}
              src={img}
              alt=""
              style={{ width: "100%", marginBottom: 8 }}
            />
          ))}
        </div>
        <div>
          <div dangerouslySetInnerHTML={{ __html: account.description }} />
          <div style={{ marginTop: 10 }}>
            <strong>Price: </strong>{" "}
            {price ? `₹${price}` : "Login to view price"}
          </div>
          <div style={{ marginTop: 10 }}>
            <label>
              Payment Method:
              <select
                value={method}
                onChange={(e) => setMethod(e.target.value)}
              >
                <option value="matrixsols">UPI / Instant Pay</option>
                <option value="phonepe">PhonePe</option>
              </select>
            </label>
          </div>
          <div style={{ marginTop: 10 }}>
            <button onClick={buy}>Buy Now</button>
          </div>
        </div>
      </div>
    </div>
  );
}
